import React, { useEffect, useState } from 'react'
import MultiSelectCheckboxGroup from '../../components/CheckBoxFilter'
import { TableListBranches } from '../../components/TableBranchState';
import { useTranslation } from 'react-i18next';
import { sixMonthsAgoFormatted, twoDaysAgoFormatted } from '../../constants/intex';
import { generateListOriginationByBranch } from '../../services/ticketSizeByBranch';

const TicketSizeByBranch = () => {
    const { t } = useTranslation();

        const branchColumns2 = ["c_branch", "Jul-2024", "Aug-2024", "Sep-2024", "Oct-2024"];
    
        const branchData3 = [
        { c_branch: "Adoor", "Jul-2024": "1.34M", "Aug-2024": "1.45M", "Sep-2024": "1.50M", "Oct-2024": "1.60M" },
        { c_branch: "Alangulam", "Jul-2024": "1.20M", "Aug-2024": "1.32M", "Sep-2024": "1.40M", "Oct-2024": "1.55M" },
        { c_branch: "Angamaly", "Jul-2024": "1.15M", "Aug-2024": "1.28M", "Sep-2024": "1.35M", "Oct-2024": "1.42M" },
        { c_branch: "Attingal", "Jul-2024": "1.50M", "Aug-2024": "1.62M", "Sep-2024": "1.70M", "Oct-2024": "1.80M" },
        { c_branch: "Irinjalakuda", "Jul-2024": "1.25M", "Aug-2024": "1.38M", "Sep-2024": "1.45M", "Oct-2024": "1.52M" },
        { c_branch: "Kalakkad", "Jul-2024": "1.42M", "Aug-2024": "1.55M", "Sep-2024": "1.60M", "Oct-2024": "1.68M" },
        { c_branch: "Kavalkinru", "Jul-2024": "1.30M", "Aug-2024": "1.40M", "Sep-2024": "1.50M", "Oct-2024": "1.60M" },
        { c_branch: "Kollam", "Jul-2024": "1.18M", "Aug-2024": "1.25M", "Sep-2024": "1.33M", "Oct-2024": "1.42M" },
        { c_branch: "Koothattukulam", "Jul-2024": "1.48M", "Aug-2024": "1.55M", "Sep-2024": "1.63M", "Oct-2024": "1.72M" },
        { c_branch: "Kottarakkara", "Jul-2024": "1.22M", "Aug-2024": "1.30M", "Sep-2024": "1.38M", "Oct-2024": "1.45M" },
        { c_branch: "Kottayam", "Jul-2024": "1.35M", "Aug-2024": "1.45M", "Sep-2024": "1.52M", "Oct-2024": "1.60M" },
        { c_branch: "Kulasekaram", "Jul-2024": "1.40M", "Aug-2024": "1.50M", "Sep-2024": "1.55M", "Oct-2024": "1.65M" },
        { c_branch: "Manur", "Jul-2024": "1.28M", "Aug-2024": "1.36M", "Sep-2024": "1.42M", "Oct-2024": "1.50M" },
        { c_branch: "Marthandam", "Jul-2024": "1.50M", "Aug-2024": "1.60M", "Sep-2024": "1.70M", "Oct-2024": "1.80M" },
        { c_branch: "Monday Market", "Jul-2024": "1.18M", "Aug-2024": "1.28M", "Sep-2024": "1.35M", "Oct-2024": "1.45M" },
        { c_branch: "Mulanthuruthy", "Jul-2024": "1.45M", "Aug-2024": "1.55M", "Sep-2024": "1.65M", "Oct-2024": "1.75M" },
        { c_branch: "Nagarcoil", "Jul-2024": "1.32M", "Aug-2024": "1.42M", "Sep-2024": "1.50M", "Oct-2024": "1.60M" },
        { c_branch: "Parippally", "Jul-2024": "1.25M", "Aug-2024": "1.35M", "Sep-2024": "1.42M", "Oct-2024": "1.50M" },
        { c_branch: "Punalur", "Jul-2024": "1.38M", "Aug-2024": "1.48M", "Sep-2024": "1.55M", "Oct-2024": "1.62M" },
        { c_branch: "Sankarankovil", "Jul-2024": "1.20M", "Aug-2024": "1.30M", "Sep-2024": "1.38M", "Oct-2024": "1.45M" },
        { c_branch: "Surandai", "Jul-2024": "1.20M", "Aug-2024": "1.32M", "Sep-2024": "1.40M", "Oct-2024": "1.55M" },
        { c_branch: "Thuravoor", "Jul-2024": "1.15M", "Aug-2024": "1.28M", "Sep-2024": "1.35M", "Oct-2024": "1.42M" },
        { c_branch: "Vaikom", "Jul-2024": "1.50M", "Aug-2024": "1.62M", "Sep-2024": "1.70M", "Oct-2024": "1.80M" },
    
    ];
    
        
        
        const [selectedFilters, setSelectedFilters] = useState<Record<string, string[]>>(() => ({
            period: ["month"],
            fromDate: [sixMonthsAgoFormatted],
            toDate: [twoDaysAgoFormatted]
            }));
    
        const filters = [
            { key: "state", type: "select", label: t("filters.state") },
            // { key: "territory", type: "select", label: t("filters.territory") },
            { key: "cluster", type: "select", label: t("filters.cluster") },
            { key: "branch", type: "select", label: t("filters.branch") },
            { key: "period", type: "singleSelect", label: t("filters.period") },
            { key: "fromDate", type: "date", label: t("filters.fromDate"), maxValue: selectedFilters.toDate },
            { key: "toDate", type: "date", label: t("filters.toDate"), maxValue: twoDaysAgoFormatted },
          ];
        const [applyFilter, setApplyFilter] = useState<boolean>(false);
        const [orginationEwiByState, setOrginationEwiByState] = useState<any[]>([]);
        const [orginationEmiByState, setOrginationEmiByState] = useState<any[]>([]);
        const [loading, setLoading] = useState<boolean>(true);
        const [error, setError] = useState<string | null>(null);
        const [branchData, setBranchData] = useState<any[]>([]);
        const [branchData2, setBranchData2] = useState<any[]>([]);
        const [branchColumns, setBranchColumns] = useState<string[]>(["c_branch"]);
        
        
        
        
        const handleFilterChange = (updatedValues: Record<string, string[]>) => {
            setSelectedFilters(updatedValues);
        };
    
        const handleCancelClick = () => {
            setSelectedFilters({
                period: ["month"],
                fromDate: [sixMonthsAgoFormatted],
                toDate: [twoDaysAgoFormatted]
            })
            setApplyFilter(!applyFilter)
        }

        const generateOriginationByBranch = async () => {
                setLoading(true);
                setBranchData([])
                setBranchData2([])
                setBranchColumns(["c_branch"])
                try {
                  const response = await generateListOriginationByBranch(selectedFilters); // Call the API function
                  if (Array.isArray(response?.data)) {
                    const periodDataArray = response.data;
              
                    setBranchColumns(prevCols => {
                      const newPeriods = periodDataArray
                        .map((item: any) => item.period)
                        // .filter((period: any) => !prevCols?.includes(period));
                      return [...prevCols, ...newPeriods];
                    });
        
              
                    setBranchData(prevData => {
                      const updatedData = [...prevData];
              
                      periodDataArray?.forEach((item: { period: string; emi_loan_details: any[] }) => {
                        const { period, emi_loan_details } = item;
                        emi_loan_details?.forEach((branch: any) => {
                            const count = branch.ticket_size_ewi?.toString() ?? ""; // fallback to 0 if bucket missing
                            const existing = updatedData.find(b => b.c_branch === branch.name);
                            if (existing) {
                              existing[period] = count;
                            } else {
                              updatedData.push({
                                c_branch: branch.name,
                                [period]: `${count}`,
                              });
                            }
                          });
                      });
              
                      return updatedData;
                    });
        
                    setBranchData2(prevData => {
                        const updatedData = [...prevData];
                
                        periodDataArray?.forEach((item: { period: string; emi_loan_details: any[] }) => {
                          const { period, emi_loan_details } = item;
                          emi_loan_details?.forEach((branch: any) => {
                              const count = branch.ticket_size_emi?.toString() ?? ""; // fallback to 0 if bucket missing
                              const existing = updatedData.find(b => b.c_branch === branch.name);
                              if (existing) {
                                existing[period] = count;
                              } else {
                                updatedData.push({
                                  c_branch: branch.name,
                                  [period]: `${count}`,
                                });
                              }
                            });
                        });        
                        return updatedData;
                      });
                  } else {
                    setError("Unexpected response format.");
                  }
        
                } catch (err) {
                  setError("Failed to fetch users");
                  console.error(err);
                } finally {
                  setLoading(false);
                }
              };

        useEffect(() => {
            generateOriginationByBranch();
        }, [applyFilter]);

  return (
    <div>
        {/* Page Content */}
        <div className="page-content">
            {/* Dynamic Grey Header */}
            <div className="header">
            {t('ticketSizeByBranch.pageTitle')}
            </div>

            <div className="content px-3">
                <MultiSelectCheckboxGroup 
                filters={filters} 
                selectedValues={selectedFilters} 
                onChange={handleFilterChange} 
                isLoading={[loading]}
                buttons={[
                    { label: t("buttons.apply"), onClick: () => setApplyFilter(!applyFilter) },
                    { label: t("buttons.cancel"), onClick: handleCancelClick },
                    { label: t("buttons.download"), onClick: () => alert("Download triggered") },
                  ]}
                />
            </div>
            <div className="row justify-content-evenly">
                <div className="col" style={{"overflow": "scroll", "width": "50%", "height": "60vh"}}>
                    <h1 style={{ fontSize: 15, fontWeight: 600, fontFamily: 'Arial', fontStyle: 'normal', textAlign: "start", paddingLeft: "15px", color: '#14213d',}}>{t('ticketSizeByBranch.Ticket Size By Branch EWI')}</h1>
                    <TableListBranches columns={branchColumns} data={branchData} />
                </div>
                <div className="col" style={{"overflow": "scroll", "width": "50%", "height": "60vh"}}>
                    <h1 style={{ fontSize: 15, fontWeight: 600, fontFamily: 'Arial', fontStyle: 'normal', textAlign: "start", paddingLeft: "15px", color: '#14213d',}}>{t('ticketSizeByBranch.Ticket Size By Branch EMI')}</h1>
                    <TableListBranches columns={branchColumns} data={branchData2} />
                </div>
            </div>

        </div>
    </div>
  )
}

export default TicketSizeByBranch